import { Component, Input, EventEmitter, Output } from '@angular/core';
import { AppState } from '../../config/state';
import { InAppBrowser } from '@ionic-native/in-app-browser';

/**
 * Generated class for the CoEventRegisterCustomQuestionComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'co-event-register-custom-question',
  templateUrl: 'co-event-register-custom-question.html',
  inputs: ['question']
})
export class CoEventRegisterCustomQuestionComponent {
  @Input() question: any;
  text: string;
  customQuestionsAnswer: any;
  requiredFieldEmpty: boolean = false;
  @Output() sendEventInfo = new EventEmitter<any>();
  constructor(private inAppBrowser: InAppBrowser, public state: AppState) {
  }

  ngOnInit() {
    this.chooseCustomAnswer("");
  }

  emitChoice(){
    this.question.answer = this.customQuestionsAnswer.toString();
    this.sendEventInfo.emit(this.question);
  }

  chooseCustomAnswer(event){
    if (event.target){
      this.customQuestionsAnswer = event.target.value;
    } else {
      if (this.question.type === 'checkbox') {
        this.customQuestionsAnswer = false;
      } else {
        this.customQuestionsAnswer = "";
      };
    };
    this.question.answer = this.customQuestionsAnswer.toString();
    this.sendEventInfo.emit(this.question);
  }

  requiredNotAnswered(bool){
    this.requiredFieldEmpty = bool;
  }

  openLink(url) {
    this.inAppBrowser.create(url, "_system");
  }

}


// WEBPACK FOOTER //
// ./src/components/co-event-register-custom-question/co-event-register-custom-question.ts